module.exports = __webpack_public_path__ + "authorization.158140b2988aceb2dd2f4d5582fc2468.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/authorization.svg
// module id = 339
// module chunks = 0